export enum CartQueryParam {
  Amount = 'amount',
  CampaignId = 'campaignId',
  CmsId = 'tcmid',
  ConsignmentHoldId = 'chid',
  Frequency = 'frequency',
  GlobalId = 'gid',
  HoldId = 'hid',
  HoldExpType = 'het',
  ItemsToAdd = 'itemsToAdd',
  Referrer = 'referrer',
  Referer = 'referer',
  RestoreCartId = 'rci',
  SiblingId = 'sibling',
  SourceCode = 'source',
  SupporterId = 'supporterId',
}
